<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search Game</h5>
          </b-card-header>
          <b-card-body>
            <b-form @submit.prevent>
              <b-row>
                <b-col sm="4">
                  <p-input v-model.trim="form.gameName" label="Game Name / Game Id" name="gameName" :handler="$v" :formData="form"/>
                </b-col>
                <b-col sm="8">
                  <small class="text-muted d-block mt-4">
                    Showing games that already have a custom thumbnail. Type at least 2 characters of a game name or id to search the full game list and add one.
                  </small>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, key) in itemList" :key="key" sm="12" md="4">
        <b-card no-body class="overflow-hidden">
          <b-card-body>
            <b-row class="mb-2">
              <b-col cols="6">
                <p class="mb-1"><strong>Custom Thumbnail</strong></p>
                <img v-if="getThumb(item.GameId)" :src="getThumb(item.GameId).ImgUrl" width="100%" class="platform-image"/>
                <b-badge v-else variant="secondary">No thumbnail</b-badge>
              </b-col>
              <b-col cols="6">
                <p class="mb-1"><strong>OCMS Thumbnail</strong></p>
                <img v-if="item.OcmsImgUrl" :src="item.OcmsImgUrl" width="100%" class="platform-image"/>
                <b-badge v-else variant="secondary">No image</b-badge>
              </b-col>
            </b-row>
            <p class="mb-1"><strong>Game Name:</strong> {{ item.GameName }}</p>
            <p class="mb-1"><strong>Game Id:</strong> {{ item.GameId }}</p>
            <p class="mb-3"><strong>Brand:</strong> {{ item.Brand || '-' }}</p>
            <b-btn @click="showUpdateModal(item)" class="btn-sm mr-1" variant="info">
              <i class="fa fa-pencil"></i> {{ getThumb(item.GameId) ? 'Replace' : 'Add' }}
            </b-btn>
            <b-btn v-if="getThumb(item.GameId)" @click="askRemove(item)" class="btn-sm" variant="danger">
              <i class="fa fa-trash"></i> Delete
            </b-btn>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <update-modal v-if="showModal" :show-modal="showModal" :update-data="updateData" @closeModal="closeModal" />

    <b-modal ref="confirm" size="sm" centered header-bg-variant="primary" hide-footer title="Remove Thumbnail">
      <div class="mb-3">Are you sure you want to delete this thumbnail?</div>
      <b-button variant="success" @click="confirmRemove">Yes</b-button>
      <b-button variant="outline-danger" @click="cancelRemove">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import UpdateModal from './UpdateThumbnail'
import { PInput } from '../../../components'
const _ = require('underscore')

export default {
  name: 'game-thumbnails',
  data () {
    return {
      form: {
        gameName: ''
      },
      searchResults: [],
      thumbList: [],
      thumbs: {},
      searchTimer: null,
      showModal: false,
      updateData: {},
      removeData: {}
    }
  },
  computed: {
    itemList: {
      get: function () {
        const term = (this.form.gameName || '').toString().trim()
        // With a search term we show server-side results; otherwise the games that
        // already have a custom thumbnail (a small list).
        return term.length >= 2 ? this.searchResults : this.thumbList
      }
    }
  },
  validations: {
    form: {
      gameName: {}
    }
  },
  watch: {
    'form.gameName': function () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.searchGames, 400)
    }
  },
  components: {
    UpdateModal,
    PInput
  },
  methods: {
    getThumb (id) {
      return this.thumbs[id]
    },
    async searchGames () {
      const q = (this.form.gameName || '').toString().trim()
      if (q.length < 2) {
        this.searchResults = []
        return
      }
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/search?q=' + encodeURIComponent(q))
        this.searchResults = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getThumbnails () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/thumbnail/list?withGameInfo=true')
        this.thumbList = data.data
        this.thumbs = _.indexBy(data.data, 'GameId')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showUpdateModal (item) {
      this.showModal = true
      this.updateData = { GameId: item.GameId, GameName: item.GameName, Thumb: this.thumbs[item.GameId] }
    },
    closeModal () {
      this.showModal = false
      this.updateData = {}
      this.getThumbnails()
    },
    askRemove (item) {
      this.removeData = item
      this.$refs.confirm.show()
    },
    cancelRemove () {
      this.removeData = {}
      this.$refs.confirm.hide()
    },
    async confirmRemove () {
      try {
        Events.$emit('loader')
        await this.$http.delete(this.API_ENDPOINT + '/game/thumbnail/' + this.removeData.GameId)
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Thumbnail deleted')
        this.cancelRemove()
        await this.getThumbnails()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  },
  async created () {
    await this.getThumbnails()
  }
}
</script>

<style scoped>
.platform-image {
  filter: drop-shadow(2px 4px 6px black);
}
</style>



// WEBPACK FOOTER //
// src/views/game/thumbnails/Thumbnails.vue